import React, { lazy, Suspense, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./hocs/Layout";
import HomePage from "./containers/HomePage/HomePage";
import { useCreateCompareList } from "./Pregrine/ComparePage/useCreateCompareList";
import { useCreateCart } from "./Pregrine/CartPage/useCreateCart";
import { useRecentlyViewed } from "./Pregrine/RecentlyViewedPage/useRecentlyViewed";
import { useDispatch } from "react-redux";
import { useStoreConfig } from "./Pregrine/StoreConfig/useStoreConfig";
import { saveConfigData } from "./features/HomePage/HomePageSlice";
import ProtectedRoute from "./components/ProtectedRoute/protectedRoute";

const Product = lazy(() =>
  import("./containers/RootComponents/Product/product")
);

const ResetPasswordPage = lazy(() =>
  import("./containers/ResetPasswordPage/ResetPasswordPage")
);

const PageNotFound = lazy(() =>
  import("./containers/PageNotFound/PageNotFound")
);

const CreateAccount = lazy(() =>
  import("./containers/CreateAccount/CreateAccount")
);

const CategoriesPage = lazy(() =>
  import("./containers/CategoriesPage/CategoriesPage")
);

const AccountInformationPage = lazy(() =>
  import("./containers/AccountInformationPage/AccountInformationPage")
);
const AddressBookPage = lazy(() =>
  import("./containers/AddressBookPage/AddressBookPage")
);

const OrderHistoryPage = lazy(() =>
  import("./containers/OrderHistoryPage/OrderHistoryPage")
);

const WishlistPage = lazy(() =>
  import("./containers/WishlistPage/WishlistPage")
);
const ApplicationCenterPage = lazy(() =>
  import("./containers/ApplicationCenterPage/ApplicationCenterPage")
);

const IdeaBookPage = lazy(() =>
  import("./containers/IdeaBookPage/IdeaBookPage")
);

const ComparePage = lazy(() => import("./containers/ComparePage/ComparePage"));

const SearchPage = lazy(() => import("./containers/SearchPage/searchPage"));
const BlogDetails = lazy(() => import("./containers/BlogDetails/BlogDetails"));
const BlogsList = lazy(() => import("./containers/BlogsList/BlogsList"));
const SignIn = lazy(() => import("./containers/SignIn/signIn"));
const CartPage = lazy(() => import("./containers/CartPage/cartPage"));

const ForgotPassword = lazy(() =>
  import("./containers/ForgotPassword/ForgotPassword")
);

const Category = lazy(() =>
  import("./containers/RootComponents/Category/category")
);
const CheckoutPage = lazy(() =>
  import("./containers/CheckoutPage/checkoutPage")
);

const CataloguePage = lazy(() =>
  import("./containers/CataloguePage/CataloguePage")
);

const AboutUs = lazy(() => import("./containers/AboutUs/AboutUs"));
const Warranty = lazy(() => import("./containers/Warranty/Warranty"));
const ContactUs = lazy(() => import("./containers/ContactUs/ContactUs"));
const ReplacementAndCancelation = lazy(() =>
  import("./containers/ReplacementAndCancelation/ReplacementAndCancelation")
);

const ShippingAndTracking = lazy(() =>
  import("./containers/ShippingAndTracking/ShippingAndTracking")
);

const TermsOfUse = lazy(() => import("./containers/TermsOfUse/TermsOfUse"));
const PrivacyPolicy = lazy(() =>
  import("./containers/PrivacyPolicy/PrivacyPolicy")
);

const BuyingGuide = lazy(() => import("./containers/BuyingGuide/BuyingGuide"));

const InspirationZoneListing = lazy(() =>
  import("./containers/InspirationZoneListing/InspirationZoneListing")
);
const InspirationZoneDetail = lazy(() =>
  import("./containers/InspirationZoneDetail/InspirationZoneDetail")
);

const BulkEnquiryPage = lazy(() =>
  import("./containers/BulkEnquiryPage/BulkEnquiryPage")
);

const ThankyouPage = lazy(() =>
  import("./containers/ThankyouPage/ThankyouPage")
);
const CancelPage = lazy(() => import("./containers/CancelPage/CancelPage"));

const Faqs = lazy(() => import("./containers/Faqs/Faqs"));

const TrackOrder = lazy(() => import("./containers/TrackOrderPage/TrackOrder"));

const NewsListPage = lazy(() => import("./containers/NewsPage/NewsListPage"));

const NewsDetailPage = lazy(() =>
  import("./containers/NewsPage/NewsDetailPage")
);

function App() {
  const dispatch = useDispatch();
  const cartProps = useCreateCart();
  const compareListProps = useCreateCompareList();
  const recentlyViewedProps = useRecentlyViewed();
  const StoreConfigProps = useStoreConfig();

  const { StoreConfigData } = StoreConfigProps;

  useEffect(() => {
    dispatch(saveConfigData(StoreConfigData));
  }, [StoreConfigData]);

  return (
    <Router>
      <Layout>
        <Routes>
          <Route
            path="*"
            element={
              <Suspense fallback={null}>
                <PageNotFound />
              </Suspense>
            }
            exact
          />
          <Route
            path="/sign-in"
            exact
            element={
              <Suspense fallback={null}>
                <SignIn />
              </Suspense>
            }
          />
          <Route
            path="/create-account"
            exact
            element={
              <Suspense fallback={null}>
                <CreateAccount />
              </Suspense>
            }
          />
          <Route
            path="/forgot-password"
            exact
            element={
              <Suspense fallback={null}>
                <ForgotPassword />
              </Suspense>
            }
          />
          <Route path="/" exact element={<HomePage />} />
          <Route
            path="/blog/:id"
            exact
            element={
              <Suspense fallback={null}>
                <BlogDetails />
              </Suspense>
            }
          />
          <Route
            path="/blogs"
            exact
            element={
              <Suspense fallback={null}>
                <BlogsList />
              </Suspense>
            }
          />
          <Route
            path="/category/:id"
            exact
            element={
              <Suspense fallback={null}>
                <Category />
              </Suspense>
            }
          />
          <Route
            path="/category/:categoryId/:id"
            exact
            element={
              <Suspense fallback={null}>
                <Category />
              </Suspense>
            }
          />
          <Route
            path="/category/:categoryId/:categoryId/:id"
            exact
            element={
              <Suspense fallback={null}>
                <Category />
              </Suspense>
            }
          />
          <Route
            path="/category/:categoryId/:categoryId/:categoryId/:id"
            exact
            element={
              <Suspense fallback={null}>
                <Category />
              </Suspense>
            }
          />
          <Route
            path="/application-center"
            element={
              <Suspense fallback={null}>
                <ApplicationCenterPage />
              </Suspense>
            }
            exact
          />

          <Route
            path="/search"
            exact
            element={
              <Suspense fallback={null}>
                <SearchPage />
              </Suspense>
            }
          />
          <Route
            path="/cart"
            exact
            element={
              <Suspense fallback={null}>
                <CartPage />
              </Suspense>
            }
          />
          <Route
            path="/checkout"
            exact
            element={
              <Suspense fallback={null}>
                <CheckoutPage />
              </Suspense>
            }
          />
          <Route
            path="/product/:id"
            exact
            element={
              <Suspense fallback={null}>
                <Product />
              </Suspense>
            }
          />
          <Route
            exact
            path="/reset-password"
            element={
              <Suspense fallback={null}>
                <ResetPasswordPage />
              </Suspense>
            }
          />
          <Route
            path="/account-information"
            exact
            element={
              <ProtectedRoute>
                <Suspense fallback={null}>
                  <AccountInformationPage />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="/address-book"
            exact
            element={
              <ProtectedRoute>
                <Suspense fallback={null}>
                  <AddressBookPage />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="/order-history"
            exact
            element={
              <ProtectedRoute>
                <Suspense fallback={null}>
                  <OrderHistoryPage />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="/thank-you"
            exact
            element={
              <Suspense fallback={null}>
                <ThankyouPage />
              </Suspense>
            }
          />
          <Route
            path="/cancel"
            exact
            element={
              <Suspense fallback={null}>
                <CancelPage />
              </Suspense>
            }
          />
          <Route
            path="/wishlist"
            exact
            element={
              <ProtectedRoute>
                <Suspense fallback={null}>
                  <WishlistPage />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="/compare-page"
            exact
            element={
              <Suspense fallback={null}>
                <ComparePage />
              </Suspense>
            }
          />
          <Route
            exact
            path="/track-order"
            element={
              <Suspense fallback={null}>
                <TrackOrder />
              </Suspense>
            }
          />
          <Route
            exact
            path="/idea-book"
            element={
              <Suspense fallback={null}>
                <IdeaBookPage />
              </Suspense>
            }
          />
          <Route
            path="/about-us"
            exact
            element={
              <Suspense fallback={null}>
                <AboutUs />
              </Suspense>
            }
          />
          <Route
            path="/contact-us"
            exact
            element={
              <Suspense fallback={null}>
                <ContactUs />
              </Suspense>
            }
          />
          <Route
            path="/replacement-and-cancellation"
            exact
            element={
              <Suspense fallback={null}>
                <ReplacementAndCancelation />
              </Suspense>
            }
          />
          <Route
            path="/warranty"
            exact
            element={
              <Suspense fallback={null}>
                <Warranty />
              </Suspense>
            }
          />
          <Route
            path="/shipping-and-tracking"
            exact
            element={
              <Suspense fallback={null}>
                <ShippingAndTracking />
              </Suspense>
            }
          />
          <Route
            path="/terms-of-use"
            exact
            element={
              <Suspense fallback={null}>
                <TermsOfUse />
              </Suspense>
            }
          />
          <Route
            path="/privacy-policy"
            exact
            element={
              <Suspense fallback={null}>
                <PrivacyPolicy />
              </Suspense>
            }
          />
          <Route
            path="/buying-guide"
            exact
            element={
              <Suspense fallback={null}>
                <BuyingGuide />
              </Suspense>
            }
          />

          <Route
            path="/catalogue"
            exact
            element={
              <Suspense fallback={null}>
                <CataloguePage />
              </Suspense>
            }
          />

          <Route
            path="/media-center"
            exact
            element={
              <Suspense fallback={null}>
                <CataloguePage />
              </Suspense>
            }
          />

          <Route
            path="/inspiration-zone-listing"
            exact
            element={
              <Suspense fallback={null}>
                <InspirationZoneListing />
              </Suspense>
            }
          />
          <Route
            path="/inspiration-zone-detail"
            exact
            element={
              <Suspense fallback={null}>
                <InspirationZoneDetail />
              </Suspense>
            }
          />

          <Route
            path="/faqs"
            exact
            element={
              <Suspense fallback={null}>
                <Faqs />
              </Suspense>
            }
          />

          <Route
            path="/news"
            exact
            element={
              <Suspense fallback={null}>
                <NewsListPage />
              </Suspense>
            }
          />

          <Route
            path="/news/:id"
            exact
            element={
              <Suspense fallback={null}>
                <NewsDetailPage />
              </Suspense>
            }
          />
          <Route
            path="/categories"
            exact
            element={
              <Suspense fallback={null}>
                <CategoriesPage />
              </Suspense>
            }
          />
          <Route
            path="/bulk-enquiry"
            exact
            element={
              <Suspense fallback={null}>
                <BulkEnquiryPage />
              </Suspense>
            }
          />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
